export default __webpack_public_path__ + "static/media/Levitate D5.2 Short term impacts of CCAM in urban transport.03fb9439.pdf";